import { Component } from '@angular/core';

@Component({
  selector: 'app-documents',
  imports: [],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent {

}
